import React from 'react';
import { useRouter } from 'next/router';
import { useTranslation } from 'next-i18next';
import ArticleCard from '../ArticleCard';
import Sidebar from '../Sidebar';
import { Pagination, Separator } from '@lb-service/ui';

const ArticlesMain = (props) => {
  const router = useRouter();
  const { locale } = router;
  const { t } = useTranslation(['common', 'blog']);
  const { posts, pageContext } = props;
  const { totalCount, searchTerm, skip } = pageContext;
  const articles = posts.map((edge) => {
    const { node } = edge;
    const cardProps = {
      slug: node.slug,
      author: node.author?.node,
      thumbnail: node.featuredImage?.node?.sourceUrl,
      date: node.date,
      title: node.title,
      category: node.categories.edges[0].node,
      locale,
    };
    return <ArticleCard key={`article-${node.slug}`} {...cardProps} />;
  });
  let searchPart = null;
  if (searchTerm) {
    searchPart = (
      <div className="col-span-12 lg:col-span-4 xl:col-span-3">
        <div className="search-query mb-20">
          <h2>{t('list.search', { searchTerm })}</h2>
        </div>
      </div>
    );
  }

  const transitionPage = (page) => {
    router.push(
      `${pageContext.basePath}/page/[page]`,
      `${pageContext.baseAsPath}/page/${page}`,
    );
  };

  return (
    <div className="bg-white py-10 main">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:max-w-7xl lg:px-8">
        <div className="grid grid-cols-12 gap-8">
          {searchPart}
          <div className="main-section col-span-12 lg:col-span-8 xl:col-span-9">
            <div className="flex justify-between flex-wrap">{articles}</div>
            <Separator />
            <Pagination
              className="my-4"
              current={skip / 10 + 1}
              pageSize={pageContext.limit}
              total={totalCount}
              onChange={(page) => transitionPage(page)}
              showTotal={(total, range) => {
                return (
                  <span>
                    {t('blog:pagination.result', {
                      beginCount: range[0].toString(),
                      endCount: range[1].toString(),
                      totalCount: total.toString(),
                      something: t('blog:articlesDowncase'),
                    })}
                  </span>
                );
              }}
            />
          </div>
          <Sidebar />
        </div>
      </div>
    </div>
  );
};

export default ArticlesMain;
